<template>
  <WAR :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0"></WAR>
</template>

<script>
import WAR from "../../components/WAR-Stacked";

import { Chart } from "highcharts-vue";
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  name: "dashboard",
  components: {
    WAR,
    highcharts: Chart
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
